import React from 'react';
import { Form } from 'antd';
import { MobileOutlined } from '@ant-design/icons';
import { UiButton, UiTextBox } from '../../../components';
import '../style.scss';

const ForgetPassword = ({
    onBackToLogin,
    onSubmit,
    loading,
    phoneNumber,
    onPhoneNumberChange,
    isPhoneValid,
}) => {
    const [form] = Form.useForm();

    const handleBackToLogin = () => {
        if (onBackToLogin) onBackToLogin();
    };

    const onFinish = (values) => {
        if (onSubmit) onSubmit(values);
    };

    const onFinishFailed = () => {
    };
    return (
        <>
            <div className="forget-password-content-title">
                Forgot Your Password
            </div>
            <div className="forget-password-content-subtitle">
                Enter your registered Mobile Number. We'll send you a OTP.
            </div>
            <Form
                form={form}
                name="forgetPassword"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
                size="large"
                className="forget-password-form"
            >
                <Form.Item
                    name="phoneNumber"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your phone number',
                        },
                        {
                            min: 10,
                            message: 'Phone number must be at least 10 digits long',
                        },
                        {
                            pattern: /^[0-9]+$/,
                            message: 'Phone number can only contain numbers',
                        },
                        {
                            whitespace: true,
                            message: 'Phone number cannot be empty',
                        },
                    ]}
                    className="forget-password-form-item"
                    style={{'padding': '0px 0px 0px 0px' }}
                >
                    <UiTextBox
                        prefix={<MobileOutlined />}
                        placeholder="Phone number"
                        className="forget-password-input"
                        value={phoneNumber}
                        onChange={onPhoneNumberChange}
                        required={true}
                        type="tel"
                        inputMode="numeric"
                        maxLength="10"
                        onKeyPress={(event) => !/[0-9]/.test(event.key) && event.preventDefault()}
                    />
                </Form.Item>
                <Form.Item className="forget-password-form-item">
                    <UiButton
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={!isPhoneValid}
                        className={`forget-password-submit-button ${isPhoneValid ? 'forget-password-submit-button-enabled' : ''}`}
                    >
                        Get Code
                    </UiButton>
                </Form.Item>
                <Form.Item className="forget-password-form-item-last">
                    <UiButton
                        type="default"
                        onClick={handleBackToLogin}
                        className="forget-password-back-button"
                    >
                        Back Login
                    </UiButton>
                </Form.Item>
            </Form>
        </>
    );
};

export default ForgetPassword;
